import SplashScreen from '@gen2/app/components/SplashScreen';
import routes from '@gen2/config/routes';
import { ToastContextProvider } from '@gen2/contexts';
import { useAuth } from '@gen2/hooks';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { gen2Theme } from '@nx-fe/components';
import { FC, useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { useRoutes } from 'react-router';
import SentryErrorModal from './components/SentryErrorModal/SentryErrorModal';

const App: FC = () => {
  const { isInitialized } = useAuth();
  const content = useRoutes(routes);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [eventId, setEventId] = useState<string>('');

  // Listen for HTTP 500 errors from axios interceptor
  useEffect(() => {
    const handleHttpError = (event: CustomEvent) => {
      const { error: httpError, sentryEventId } = event.detail;
      setError(httpError);
      setEventId(sentryEventId);
      setShowModal(true);
    };

    window.addEventListener('http-error-500', handleHttpError as EventListener);

    return () => {
      window.removeEventListener(
        'http-error-500',
        handleHttpError as EventListener,
      );
    };
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    setError(null);
    setEventId('');
  };

  return (
    <ThemeProvider theme={gen2Theme}>
      <ToastContextProvider>
        <CssBaseline />
        {isInitialized ? content : <SplashScreen />}
      </ToastContextProvider>
      <Toaster />

      <SentryErrorModal
        open={showModal}
        onClose={handleCloseModal}
        error={error || undefined}
        eventId={eventId}
      />
    </ThemeProvider>
  );
};

export default App;
